import React from "react";
import { PublicHeader } from "./PublicHeader";
import { Footer } from "@/components/memorial/Footer";

interface PublicLayoutProps {
  children: React.ReactNode;
}

export const PublicLayout = ({ children }: PublicLayoutProps) => {
  return (
    <div className="min-h-screen bg-brand-background flex flex-col">
      <PublicHeader />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};
